
export const webUrl = 'https://ilogically.com';// appToken.js
export const webUrlNode = 'https://api.ilogically.com';// appToken.js

function getDomainToken() {
  if (typeof window === "undefined") return "";

  const host = window.location.hostname.toLowerCase();

  // remove leading www
  const cleanHost = host.startsWith("www.") ? host.slice(4) : host;

  // classmock handling
  if (cleanHost === "classmock.com") {
    return "classmock";
  }

  if (cleanHost.endsWith(".classmock.com")) {
    // demo.classmock.com -> demo
    return cleanHost.replace(".classmock.com", "");
  }

  // all other domains → return full domain
  return cleanHost;
}

// export const appTokenString = getDomainToken();

export const appTokenString = "priyara.wednessday.com";


// JosefCrack@2424